exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".IconButton {\n  border-radius: 50%;\n  height: 40px;\n  padding: 2px;\n  transition: color 0.25s, background-color 0.25s, border-color 0.25s, box-shadow 0.25s, -webkit-box-shadow 0.25s;\n  width: 40px; }\n  .IconButton > .icon {\n    font-size: 32px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Buttons/IconButton/IconButton.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Buttons/IconButton/IconButton.css
// module chunks = 0